import api from "../api";

const api_type = 'v1'

export const GetUserPage = params => { return api.post(api_type+`/user/page`, params) }
export const GetUserAll = params => { return api.post(api_type+`/user/all`, params) }
export const QuitHandover = params => { return api.post(api_type+`/quit/handover`, params) }
export const GetUserInfo = params => { return api.post(api_type+`/user/info`, params) }
export const UserSave = params => { return api.post(api_type+`/user/save`, params) }






// WEBPACK FOOTER //
// ./src/api/v1/user_api.js